// import "./Header.scss";
// import logo from "../../assets/images/LagosLogo.png";
// import arrowsgroupheader from "../../assets/images/arrowsgroupheader.png";
// import burgericon from "../../assets/images/burgericon.png";
// import close from "../../assets/images/close.png";
// import { useEffect, useRef } from "react";
// const Header = () => {
//   const menubox = useRef();
//   const menus = useRef();
//   const onMenu = () => {
//     menubox.current.classList.remove("menuswipeup");
//     menubox.current.classList.add("menubox");
//     menubox.current.style.setProperty("display", "block");
//   };
//   const onCloseMenu = () => {
//     menubox.current.classList.add("menuswipeup");
//     // menubox.current.classList.remove("menubox")
//     // menubox.current.style.removeProperty("display","block")
//   };
//   let path = window.location.pathname;
//   useEffect(() => {
//     if (path === "/") {
//       menus.current.children[0].classList.add("active");
//       menus.current.children[1].classList.remove("active");
//       menus.current.children[2].classList.remove("active");
//     } else if (path === "/Resilience") {
//       menus.current.children[0].classList.remove("active");
//       menus.current.children[1].classList.add("active");
//       menus.current.children[2].classList.remove("active");
//     } else if (path === "/Connect") {
//       menus.current.children[0].classList.remove("active");
//       menus.current.children[1].classList.remove("active");
//       menus.current.children[2].classList.add("active");
//     }
//   }, [path]);
//   return (
//     <>
//       <div className="header">
//         <img
//           alt="arrows-group"
//           src={arrowsgroupheader}
//           className="arrowsgroupheader"
//         />
//         <div className="container header-div">
//           <img alt="logo" src={logo} className="logo" />
//           <div id="mobileheader">
//             <img
//               src={burgericon}
//               alt="menu"
//               className="headerbutton"
//               onClick={onMenu}
//             />
//           </div>
//           <div id="header" ref={menus} className="menus desktop">
//             <a href="/">Home</a>
//             <a href="/Resilience">Pathway to Resilience</a>
//             <a href="/Connect">Ways to get involved</a>
//             <a href="/Connect">Projects</a>
//           </div>
//         </div>
//       </div>
//       <div className="menubox" ref={menubox}>
//         <img
//           alt="close"
//           src={close}
//           className="close-button"
//           onClick={onCloseMenu}
//         />
//         <div className="custom-col">
//           <a href="/">Home</a>
//           <a href="/Resilience">Pathway to Resilience</a>
//           <a href="/Connect">Ways to Connect</a>
//           <a href="/Connect">Projects</a>
//         </div>
//       </div>
//     </>
//   );
// };

// export default Header;

import "./Header.scss";
import logo from "../../assets/images/LagosLogo.png";
import arrowsgroupheader from "../../assets/images/arrowsgroupheader.png";
import burgericon from "../../assets/images/burgericon.png";
import close from "../../assets/images/close.png";
import { useEffect, useRef } from "react";

const menuItems = [
  { name: "Home", path: "/" },
  { name: "Pathway to Resilience", path: "/Resilience" },
  { name: "Ways to Get Involved", path: "/Connect" },
  { name: "Projects", path: "/Project" },
  {
    name: <>
      Risk Map
      &nbsp;<span><svg xmlns="http://www.w3.org/2000/svg" width="10.827" height="10.827" viewBox="0 0 10.827 10.827">
        <g id="Icon_feather-external-link" data-name="Icon feather-external-link" transform="translate(-4 -3.793)">
          <path id="Path_88264" data-name="Path 88264" d="M12.516,12.741v3.207a1.069,1.069,0,0,1-1.069,1.069H5.569A1.069,1.069,0,0,1,4.5,15.948V10.069A1.069,1.069,0,0,1,5.569,9H8.775" transform="translate(0 -2.897)" fill="none" stroke="#50acde" stroke-linecap="round" stroke-linejoin="round" stroke-width="1" />
          <path id="Path_88265" data-name="Path 88265" d="M22.5,4.5h3.207V7.707" transform="translate(-11.587)" fill="none" stroke="#50acde" stroke-linecap="round" stroke-linejoin="round" stroke-width="1" />
          <path id="Path_88266" data-name="Path 88266" d="M15,10.379,20.879,4.5" transform="translate(-6.759)" fill="none" stroke="#50acde" stroke-linecap="round" stroke-linejoin="round" stroke-width="1" />
        </g>
      </svg>
      </span>
    </>,
    path: "https://lcarp.bcg.com/"
  },
];

const Header = () => {
  const menuBoxRef = useRef();
  const menusRef = useRef();

  const handleMenuOpen = () => {
    menuBoxRef.current.style.display = "block";
    menuBoxRef.current.classList.add("menubox-visible");
    menuBoxRef.current.classList.remove("menuswipeup");
  };

  const handleMenuClose = () => {
    menuBoxRef.current.classList.add("menuswipeup");
    menuBoxRef.current.classList.remove("menubox-visible");
    setTimeout(() => {
      menuBoxRef.current.style.display = "none";
    }, 300);
  };

  useEffect(() => {
    const currentPath = window.location.pathname;
    Array.from(menusRef.current.children).forEach((child, index) => {
      if (menuItems[index].path === currentPath) {
        child.classList.add("active");
      } else {
        child.classList.remove("active");
      }
    });
  }, []);

  return (
    <>
      <div className="header">
        <img
          alt="arrows-group"
          src={arrowsgroupheader}
          className="arrowsgroupheader"
        />
        <div className="container header-div">
          <img alt="logo" src={logo} className="logo" />
          <div id="mobileheader">
            <img
              src={burgericon}
              alt="menu"
              className="headerbutton"
              onClick={handleMenuOpen}
            />
          </div>
          <div id="header" ref={menusRef} className="menus desktop">
            {menuItems.map((item, index) => {
              if (index === 4) {
                return (
                  <a key={index} href={item.path} target="_blank" rel="noopener noreferrer">
                    {item.name}
                  </a>
                );
              }
              return (
                <a key={index} href={item.path}>
                  {item.name}
                </a>
              )
            })}
          </div>
        </div>
      </div>
      <div className="menubox" ref={menuBoxRef} style={{ display: "none" }}>
        <img
          alt="close"
          src={close}
          className="close-button"
          onClick={handleMenuClose}
        />
        <div className="custom-col">
          {menuItems.map((item, index) => (
            <a key={index} href={item.path}>
              {item.name}
            </a>
          ))}
        </div>
      </div>
    </>
  );
};

export default Header;
